/** Single source of truth for the customer-requests flow's route paths. */
export const CUSTOMER_REQUESTS_BASE =
  "/material-compliance/customer-studio/requests"

export const customerRequestImportPath = `${CUSTOMER_REQUESTS_BASE}/import`

export const customerRequestConfirmPath = (id: string) =>
  `${CUSTOMER_REQUESTS_BASE}/import/confirm?id=${id}`

export const customerRequestDetailPath = (id: string) =>
  `${CUSTOMER_REQUESTS_BASE}/${id}`

export const customerRequestProcessPath = (id: string, step?: string) =>
  `${CUSTOMER_REQUESTS_BASE}/${id}/process${step ? `/${step}` : ""}`

export const CONFORMITY_BASE = "/material-compliance/customer-studio/conformity"

/** The editor for one persisted declaration. */
export const conformityEditPath = (id: string) =>
  `${CONFORMITY_BASE}/edit/${id}`

/** The inbox filtered to one freshly-generated batch — where the Generate screen
 *  lands after it persists the drafts, so a chat generate lands in the same place. */
export const conformityBatchPath = (ids: string[]) =>
  ids.length > 0 ? `${CONFORMITY_BASE}?ids=${ids.join(",")}` : CONFORMITY_BASE

export const conformityCreatePath = (preselect?: {
  scope: "customer" | "product"
  ids: string[]
  /** The regulations the request asks (FRAMEWORK_ORDER keys), handed to the
   *  generate screen as its preselection (TUR-1734; the picker reads it in T8). */
  regulationKeys?: readonly string[]
}) => {
  if (!preselect || preselect.ids.length === 0) return `${CONFORMITY_BASE}/new`
  const param = preselect.scope === "customer" ? "customerId" : "productId"
  const params = new URLSearchParams({
    scope: preselect.scope,
    [param]: preselect.ids.join(","),
  })
  // An empty choice is kept as `regulations=` (none picked); only an absent one
  // (flag off) leaves the parameter out.
  if (preselect.regulationKeys !== undefined) {
    params.set("regulations", preselect.regulationKeys.join(","))
  }
  return `${CONFORMITY_BASE}/new?${params.toString()}`
}
